import React from 'react';
import PropTypes from 'prop-types';

const BottomTriangle = ({ size, color, shadowColor }) => (
  <div style={{
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, 100%)',
    WebkitTransform: 'translate(-50%, 100%)',
    MozTransform: 'translate(-50%, 100%)',
    MsTransform: 'translate(-50%, 100%)',
    OTransform: 'translate(-50%, 100%)',
    width: 0,
    height: 0,
    borderLeft: `${size}px solid transparent`,
    borderRight: `${size}px solid transparent`,
    borderTop: `${size}px solid ${color}`,
    boxShadow: `5px 5px 15px 0px ${shadowColor}`,
  }}
  />
);

BottomTriangle.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  shadowColor: PropTypes.string,
};

BottomTriangle.defaultProps = {
  shadowColor: '#FFFFFF',
};

export default BottomTriangle;



// WEBPACK FOOTER //
// ./src/assets/BottomTriangle.jsx